import { RouteObject } from 'react-router'
import React, { lazy } from 'react'
import ProtectRouter from '../components/protect.router'

const Company = lazy(() => import('../containers/company/company'))
const CompanyDescribe = lazy(() => import('../containers/company/describe/company.describe'))

const CompanyRouter: RouteObject[] = [
    {
        path: '/app/company',
        element: <ProtectRouter privateRouter={true} scopes={[ 'cp:ra', 'cp:r']}>
            <Company/>
        </ProtectRouter>
    },
    {
        path: '/app/company/:companyCnpj/description',
        element: <ProtectRouter privateRouter={true} scopes={[ 'cp:ra', 'cp:r']}>
            <CompanyDescribe/>
        </ProtectRouter>
    },
    {
        path: '/app/company/:companyCnpj',
        element: <ProtectRouter privateRouter={true} scopes={[ 'cp:ra', 'cp:r']}>
            <CompanyDescribe/>
        </ProtectRouter>
    }
]

export default CompanyRouter
